import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";
import { PhilosophyCreateRequest } from "../Lib/types";

export const philosophyDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getOne: async ({ resource, id }) => {
      const url = "/cms/league/philosophy";
      try {
        const { data: response } = await httpClient.get(
          "/cms/league/philosophy"
        );
        const data = await { ...response };
        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    update: async ({
      resource,
      variables,
    }: {
      id: string;
      resource: string;
      variables: PhilosophyCreateRequest;
    }) => {
      const url = "/cms/league/philosophy";
      const { mainPhotoUrl, title, philosophy } = variables;

      const philosophyResult: any[] = [];
      philosophy.map((elem: any) => {
        if (!elem.media.type) elem.media = null;
        if (!elem.text && !elem.media) elem = null;
        if (elem) philosophyResult.push(elem);
      });
      try {
        const { data } = await httpClient.post(url, {
          mainPhotoUrl,
          title,
          philosophy: philosophyResult,
        });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
